export default "__VITE_ASSET__DjgRp3Tv__"